import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function ChapterWisePYQ() {

    const pageTitleText = "Chapter wise PYQ ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="chapter-wise-pyq" 
      />

    </>
  );
} 

export default ChapterWisePYQ;